"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _MenuItem = _interopRequireDefault(require("./MenuItem.style"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Label = _interopRequireDefault(require("../../Label"));

var _Badge = _interopRequireDefault(require("../../Badge"));

var _Avatar = _interopRequireDefault(require("../../Avatar"));

var _dec, _class;

let MenuItem = (_dec = (0, _reactJss.default)(_MenuItem.default), _dec(_class = class MenuItem extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleClickLeftIcon = this.handleClickLeftIcon.bind(this);
    this.handleClickRightIcon = this.handleClickRightIcon.bind(this);
  }

  handleClick() {
    const {
      value,
      visibility,
      onClick
    } = this.props;
    if (visibility === 'disabled') return;
    onClick(value);
  }

  handleClickLeftIcon() {
    const {
      value,
      onClickLeftIcon,
      visibility
    } = this.props;
    if (visibility === 'disabled') return;
    onClickLeftIcon(value);
  }

  handleClickRightIcon() {
    const {
      value,
      onClickRightIcon,
      visibility
    } = this.props;
    if (visibility === 'disabled') return;
    onClickRightIcon(value);
  }

  renderChildren() {
    const {
      classes,
      size,
      children
    } = this.props;
    if (!children) return null;

    try {
      if (size === 'small') {
        throw new Error('Small menuItem should not contain a child');
      }
    } catch (e) {
      console.error(e); // eslint-disable-line no-console

      return null;
    }

    return _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.labelContainerContent, classes.children)
    }, children);
  }

  render() {
    const {
      id,
      classes,
      className,
      leftIcon,
      rightIcon,
      label,
      visibility,
      value,
      activeItem,
      badge,
      avatar,
      size
    } = this.props;
    return _react.default.createElement("div", {
      name: id,
      className: (0, _clsx.default)(className, classes.menuItem, classes[size], {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      }, {
        active: activeItem === value
      }),
      onClick: this.handleClick
    }, avatar ? _react.default.createElement(_Avatar.default, {
      className: (0, _clsx.default)(classes.avatar),
      label: label,
      src: avatar,
      size: size
    }) : null, leftIcon ? _react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.icon, classes.iconLeft),
      type: leftIcon,
      size: "medium",
      onClick: this.handleClickLeftIcon
    }) : null, _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.labelContainer)
    }, _react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.labelContainerContent, classes.label),
      value: label
    }), this.renderChildren()), badge ? _react.default.createElement(_Badge.default, {
      className: (0, _clsx.default)(classes.badge),
      value: badge,
      size: "large"
    }) : null, rightIcon ? _react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.icon, classes.iconRight),
      type: rightIcon,
      size: "medium",
      onClick: this.handleClickRightIcon
    }) : null);
  }

}) || _class);
MenuItem.defaultProps = {
  id: null,
  value: null,
  visibility: 'visible',
  leftIcon: null,
  rightIcon: null,
  error: false,
  onClick: () => {},
  onClickRightIcon: () => {},
  onClickLeftIcon: () => {},
  avatar: '',
  size: 'medium',
  children: null
};
var _default = MenuItem;
exports.default = _default;